import { All, KeyValue } from "../interfaces";
import { connect } from "react-redux";
import * as actions from "../common/actions";
import { Dispatch } from "react";
import ProFormaTable from "../components/SOD/MarketShare/Pro-Forma/ProFormaTable";

export function mapStateToProps({ appState }: All) {
  return {
    appState: (appState as KeyValue)[appState.app],
  };
}
function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateUi: (
      uiField: string,
      value: KeyValue[] | boolean | string | KeyValue,
    ) => {
      dispatch(actions.updateUi(uiField, value));
    },
    updatePage: (page: number) => {
      dispatch(actions.updatePagination("pageNumber", page));
      dispatch(actions.searchPush());
    },
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ProFormaTable);
